<style lang = 'scss'>
  @import '../assets/scss/public.scss';
  @import '../assets/css/iconfont/iconfont.css';
  @import '../assets/scss/modalStyle.scss';
  .layout-sider{
    height: 100%;
    overflow: hidden;
  }
  .layout{
    /*border: 1px solid #d7dde4;*/
    background: #f5f7f9;
    position: relative;
    border-radius: 4px;
    overflow: auto;
    height: 100%;
    .reallayout{
      height: 100%;
    }
    .layout-layout {
      height: 100%;
      min-width: 1000px;
      .centerDiv{
        width: 400px;
        height: 150px;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        text-align: center;
        .loadingImage{
          width: 400px;
          height: 300px;
          background: url('../assets/loading.gif');
        }
        .fontClass{
          font-size: 16px;
          text-align: center;
        }
      }
    }
    .layout-footer {
      text-align: center;
    }
  }
  .layout-header-bar{
    background: #fff;
    box-shadow: 0 1px 15px rgba(0,0,0,.3);
  }
  .layout-logo-left{
    width: 90%;
    height: 30px;
    background: #5b6270;
    border-radius: 3px;
    margin: 15px auto;
  }
  .menu-icon{
    transition: all .3s;
  }
  .rotate-icon{
    transform: rotate(-90deg);
  }
  .menu-item span{
    display: inline-block;
    overflow: hidden;
    width: 120px;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: bottom;
    transition: width .2s ease .2s;
  }
  .menu-item i{
    transform: translateX(0px);
    transition: font-size .2s ease, transform .2s ease;
    vertical-align: middle;
    font-size: 16px;
  }
  .menu-item .ivu-menu-item{
    padding-left: 36px;
  }
  .menu-item .ivu-menu-item-group-title {
    font-size: 16px!important;
  }
  .collapsed-menu span{
    width: 0px;
    transition: width .2s ease;
  }
  .collapsed-menu i{
    transform: translateX(0);
    transition: font-size .2s ease .2s, transform .2s ease .2s;
    vertical-align: middle;
    font-size: 22px;
  }
  .sider-top{
    height: 70px;
    @include bgimg-contain ('../assets/logo.png');
  }
  .sider-top-short{
    height: 50px;
    @include bgimg-contain ('../assets/logo4.png');
  }
  .rightContent{
    /deep/.ivu-table-wrapper{
      overflow: inherit;
    }
    .ivu-table .demo-table-error-row td{
      background-color: #ff6600;
      color: #fff;
    }
    .ivu-table .ivu-table-header th{
      background-color: #ececec;
      background: #ececec;
      height: 48px;
      /*color: #fff;*/
    }
    .ivu-page{
      height: 36px;
      margin-top: 10px;
      text-align: center;
    }
    .ivu-table-border th{
      background-color: #ececec;
      background: #ececec;
    }
    .ivu-table-cell {
      padding: 0 5px;
    }
    .ivu-table-cell button{
      margin: 0 2px 0px;
      padding: 0 5px;
      i{
        font-size: 18px;
      }
      span{
        margin-left: 1px;
        font-size: 14px
      }
    }
    .topButtDiv{
      .topSearch {
        .rightButt{
          color: #fff;
          font-size: 14px;
          margin: 0 3px 0 0;
          cursor: pointer;
          .rightIcon{
            font-size: 16px;
            margin-right: 4px;
            color: #fff;
          }
        }
        .ivu-input-group-append {
          background-color: #2d8cf0;
          width: 80px;
          text-align: right;
        }
        /deep/ .ivu-input-icon{
          right: 40px;
          color: #888;
          margin-right: 40px;
          cursor: pointer;
        }
      }
      button{
        /*margin: 8px 2px 0px;*/
        padding: 0 5px;
        i{
          font-size: 18px;
        }
        span{
          margin-left: 1px;
          font-size: 14px
        }
      }
    }
  }
  .logo-father{
    padding: 10px;
    /*border-bottom: 1px solid #64676A*/
  }
  .closelogindiv{
    display: inline-block;
    float: right;
    font-size: 16px;
    height: 56px;
    margin-right: 15px;
    line-height: 56px;
    .titleName{
      display: inline-block;
      margin-right: 5px;
    }
    button{
      margin: 0 2px 0;
      padding: 0 5px;
      i{
        font-size: 16px;
      }
      span{
        margin-left: 1px;
        font-size: 14px
      }
    }
  }
  .border-bott{
    .ivu-menu-item-group-title{
      /*border-bottom: 1px solid #64676A*/
    }
  }
  .modal-content {
    text-align: center;
    font-size: 16px;
  }
  /*.layout .ivu-menu-vertical .ivu-menu-item-group-title{
    border-bottom: 1px solid #64676A!important;
  }*/
  .rightContent{
    overflow: auto;
  }
  /*单个菜单选中样式*/
  .layout{
    /*单个MuneItem样式*/
    .singleItem {
      font-size: 18px;
      padding-left: 20px;
    }
    .ivu-menu-dark.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu), .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu-title-active:not(.ivu-menu-submenu) {
      color: #fff;
    }
    .ivu-menu-dark.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu), .ivu-menu-dark.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu):hover, .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu-title-active:not(.ivu-menu-submenu), .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu-title-active:not(.ivu-menu-submenu):hover {
      background: #2d8cf0;
    }
    .menu-item .iconfont {
      font-size: 18px;
    }
    .ivu-menu-item{

    }
    .ivu-menu-vertical .ivu-menu-item, .ivu-menu-vertical .ivu-menu-submenu-title {
      padding: 14px 20px;
      height: 55px;
      line-height: 27px;
    }
    .ivu-modal-header p, .ivu-modal-header-inner {
      text-align: center;
      font-size: 18px;
    }
  }

  /* 选中后的小三角 */
  .ivu-menu-item-selected::after {
    content: '';
    border: solid transparent;
    width:0;
    height:0;
    border-top:8px solid transparent;
    border-bottom: 8px solid transparent;
    border-left: 8px solid transparent;
    border-right: 8px solid #fff;
    right: 0;
    /*display: inline-block;*/
    vertical-align: middle;
    margin-top: 6px;
    position: absolute;
    border-right-color: #f5f7f9
  }
  .ivu-table-row-highlight td, .ivu-table-stripe .ivu-table-body tr.ivu-table-row-highlight:nth-child(2n) td, .ivu-table-stripe .ivu-table-fixed-body tr.ivu-table-row-highlight:nth-child(2n) td, tr.ivu-table-row-highlight.ivu-table-row-hover td {
    background-color: #d2d4d6!important;
    /*color: #fff!important;*/
  }
  /*.ivu-table-stripe .ivu-table-body tr.ivu-table-row-hover td,.ivu-table-stripe .ivu-table-fixed-body tr.ivu-table-row-hover td{background-color:#3596F9!important;color: #fff!important;}*/
  tr.ivu-table-row-hover td{
    background-color: #d2d4d6!important;
    /*color: #fff!important;*/
  }
  .ivu-modal{
    .ivu-modal-header{
      border-bottom: 1px solid #ccc;
    }
    .ivu-modal-footer{
      border-top: 1px solid #ccc;
    }
  }
  .ivu-table-cell a{
    color: #2d8cf0;
    text-decoration: underline;
  }
  .ivu-table-row-highlight a, .ivu-table-row-hover a{
    /*color: #BD0A01;*/
  }
  .layout .ivu-menu-dark.ivu-menu-vertical .ivu-menu-item-group-title{
    /*padding-left: 38px!important;*/
    overflow: hidden;
  }
  .titleClass>.ivu-menu-item-group-title{
    padding-right: 30px;
  }
  .siderhandled{
    position: relative;
    overflow: hidden;
    width: 100%;
    /*height: calc(~"100% - 70px");*/
    height: calc(100%);
  }
  .siderNohand{
    position: relative;
    overflow: hidden;
    height: calc(100%);
    width: 100%;
  }
  .siderContentDiv{
    position: absolute!important;
    left: 0;
    top: 0;
    right: -17px;
    bottom: 0;
    overflow-x: hidden;
    overflow-y: scroll;
  }
  .headerDiv {
    margin-right: 5px;
    display: inline-block;
    vertical-align: top;
    &:hover{
      background: #2db7f5;
    }
  }
  .Breadcrumbstyle{
    height: 56px;
    line-height: 56px;
    display: inline-block
  }
  .un,.un:link,.un:visited,.un:hover,.un:active{
    text-decoration: none!important;
    color:inherit!important;
  }
  .ivu-input-icon-normal+.ivu-input{
    padding-right: 32px!important;
  }
  .ivu-modal-content{
    /deep/.ivu-btn-large{
      padding: 3px 8px!important;
      font-size: 14px!important;
    }
  }
</style>

<template style="{'height': '100%'}">
  <div class="layout">
    <Layout class="reallayout">
      <Sider ref="side1" hide-trigger collapsible :collapsed-width="0" v-model="isCollapsed" class='layout-sider'>
        <!-- 左上角Logo -->
        <!-- 中部菜单 -->
        <div :class="[siderSelect ? 'siderhandled siderContentDiv' : 'siderNohand siderContentDiv']" :style="{'width': this.muneListWidth, 'font-size': '18px'}">
          <div class="logo-father">
            <div :class="logoClass"></div>
          </div>
          <Menu ref="side_menu" theme="dark" :open-names="openWhereUl" style="width: 100%;" :active-name='openWhereLi' accordion :class="menuitemClasses" @on-select='handleSelect'>
            <div v-for="(value, index) in breadListPost" :key="index">
              <!-- 无下拉 -->
              <MenuItem :name="value.openWhereLi" class='singleItem' v-if='value.type == 0'>
                <i :class="value.class"></i>
                <span><a href="#" class="un" :title="value.name">{{value.name}}</a></span>
              </MenuItem>
              <!-- 有下拉 -->
              <Submenu :name="value.whereUl" v-if='value.type == 1'>
                <template slot="title">
                  <i :class="value.class"></i>
                  <span><a href="#" class="un" :title="value.name" style="font-size: 18px;">{{value.name}}</a></span>
                </template>
                <div v-for="(item, index) in value.list" :key="index">
                  <MenuItem :name="item.openWhereLi" style="padding-left: 38px;" v-if='item.listType == 1'>
                    <i :class="item.class"></i>
                    <span><a href="#" class="un" :title="item.name">{{item.name}}</a></span>
                  </MenuItem>
                </div>
              </Submenu>
              <!-- 下拉带标题 -->
              <Submenu :name="value.whereUl" v-if='value.type == 2'>
                <!-- 最外层的Ul -->
                <template slot="title">
                  <i :class="value.class"></i>
                  <span>{{value.name}}</span>
                </template>
                <!-- 第二层循环判断每个 -->
                <div v-for="(item, index) in value.list" :key="index">
                  <!-- title是小标题 -->
                  <MenuGroup :title="item.name" v-if='item.listType == 1' class='titleClass'>
                    <div v-for="(val, ind) in item.list" :key="ind">
                      <MenuItem :name="val.openWhereLi" v-if='val.listType == 1'>
                        <i :class="val.class"></i>
                        <span><a href="#" class="un" :title="val.name">{{val.name}}</a></span>
                      </MenuItem>
                    </div>
                  </MenuGroup>
                  <!-- 混合类型混入不小标题的下拉 -->
                  <!-- <div v-for="(item, index) in value.list" :key="index">
                    <MenuItem :name="item.openWhereLi" v-if='item.listType == 1'>
                      <i :class="item.class"></i>
                      <span>{{item.name}}</span>
                    </MenuItem>
                  </div> -->
                </div>
              </Submenu>
            </div>
          </Menu>
        </div>
      </Sider>
      <Layout class='layout-layout'>
        <!-- 内容上侧点击头部 -->
        <Header :style="{padding: 0, zIndex: '999'}" class="layout-header-bar">
          <!-- 缩放按钮 -->
          <Tooltip content="点击展开" theme="light" placement="bottom-start" :style="{verticalAlign: 'top'}" v-if='isCollapsed'>
            <div class='headerDiv'>
              <Icon @click.native="collapsedSider" :class="rotateIcon" :style="{padding: '16px 16px'}" type="md-menu" size="24"></Icon>
            </div>
          </Tooltip>
          <Tooltip content="点击收起" theme="light" placement="bottom-start" :style="{verticalAlign: 'top'}" v-if='!isCollapsed'>
            <div class='headerDiv'>
              <Icon @click.native="collapsedSider" :class="rotateIcon" :style="{padding: '16px 16px'}" type="md-menu" size="24"></Icon>
            </div>
          </Tooltip>
          <!-- 面包屑 -->
          <Breadcrumb class='Breadcrumbstyle' separator="<b style='color: #000'>></b>">
            <BreadcrumbItem v-for="(value, index) in breadList" :key="value.name">
              <span @click="clickbread(value.path, index, value)" v-if='value.type==1'>
                <a>{{value.name}}</a>
              </span>
              <!-- 不可点击 -->
              <span v-if='value.type==0'>
                {{value.name}}
              </span>
              <!-- 需要加後綴活動名稱 -->
              <span v-if='value.type==2'>
                {{value.name}}
                <span v-show='activeName'> -- {{activeName}}</span>
              </span>
              <!-- 需要加後綴活動名稱且必须可以点击的 -->
              <span @click="clickbread(value.path, index, value)" v-if='value.type==3'>
                <a>{{value.name}}
                  <span v-show='activeName'> -- {{activeName}}</span>
                </a>
              </span>
            </BreadcrumbItem>
          </Breadcrumb>
          <!-- 退出登录 -->
          <div class="closelogindiv">
            <span class="titleName">您好，{{adminName}}</span>
            <Button size='default' type='error' @click.native="closeLogin" icon="ios-power">
              退出登录
            </Button>
          </div>
        </Header>
        <div :style="{margin: '15px 15px 5px', background: 'rgb(255, 255, 255)', height: '100%', minHeight: '260px', overflow: 'auto'}" class = 'rightContent'>
          <!-- 正常进入 -->
          <div v-show='showPageAuthor === 1' style="height: 100%">
            <router-view/>
          </div>
          <!-- 加载页面show为0时显示 -->
          <div v-show='showPageAuthor === 0' style="width:100%;height:100%;position: relative;background: #fff">
            <div class="centerDiv">
              <svg width="70px" height="calc(100% - 24px)" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="lds-rolling">
                <circle cx="50" cy="50" fill="none" stroke="#456caa" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138" transform="rotate(209.28 50 50)">
                  <animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50" keyTimes="0;1" dur="0.8s" begin="0s" repeatCount="indefinite">
                  </animateTransform>
                </circle>
              </svg>
              <p class="fontClass">正在加载....</p>
            </div>
          </div>
          <!-- <div class="centerDiv">
            <div class="loadingImage"></div>
            <p class="fontClass">正在加载...</p>
          </div>
        </div> -->
          <!-- 没有权限进入该页面 -->
          <div v-show='showPageAuthor === 2'></div>
        </div>
        <Footer class='layout-footer' >
          <div>Copyright &copy; &nbsp;微图科技 版权所有</div>
        </Footer>
      </Layout>
    </Layout>
    <Modal
      v-model="modal1"
      title="提示"
      @on-ok="checkOk"
      @on-cancel="checkCancel"
      :closable='false'
      :ok-text='okText'
      :cancel-text='cancelText'
      class-name='common'
      transfer>
      <p class="modal-content">{{modalText}}</p>
    </Modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { MenuItem } from 'view-design'
import { getUserInfo } from '@/api/getApi'
import { getOrgCode, getUrlCode, removeCookie, confirm, handleRes, backMessage } from '@/js/public'
export default {
  name: 'adminMenu',
  components: { MenuItem },
  data () {
    return {
      siderSelect: false,
      isCollapsed: false,
      adminName: '',
      modal1: false,
      modalText: '确定退出？',
      okText: '确认退出',
      cancelText: '取消',
      muneIndexName: '功能总览',
      muneListData: {
        // 超管
        orgList: { // 功能页0
          type: '-1', // 0,1,2分别代表不下拉，下拉，下拉带标注
          openWhereUl: '',
          openWhereLi: 'orgList',
          name: '报名机构列表',
          class: 'iconfont icon-qiapian',
          breadListData: [{
            name: '报名机构列表',
            path: `/${this.$orgid}/functionIndex`,
            type: '1' // 1为可点击，0为不可点击
          }]
        },
        // 普通户用
        caseList: { // 功能页0
          type: '-1', // 0,1,2分别代表不下拉，下拉，下拉带标注
          openWhereUl: '',
          openWhereLi: 'caseList',
          name: '案例列表',
          class: 'iconfont icon-qiapian',
          breadListData: [{
            name: '案例列表',
            path: `/${this.$orgid}/caseList`,
            type: '0' // 1为可点击，0为不可点击
          }]
        },
        userInfo: { // 功能页0
          type: '-1', // 0,1,2分别代表不下拉，下拉，下拉带标注
          openWhereUl: '',
          openWhereLi: 'userInfo',
          name: '报名信息',
          class: 'iconfont icon-user',
          breadListData: [{
            name: '报名信息',
            path: `/${this.$orgid}/userInfo`,
            type: '0' // 1为可点击，0为不可点击
          }]
        },
        // 普通户用
        workList: { // 功能页0
          type: '-1', // 0,1,2分别代表不下拉，下拉，下拉带标注
          openWhereUl: '',
          openWhereLi: 'workList',
          name: '作品列表',
          class: 'iconfont icon-qiapian',
          breadListData: [{
            name: '作品列表',
            path: `/${this.$orgid}/workList`,
            type: '0' // 1为可点击，0为不可点击
          }]
        }
      },
      // 定义子路由的菜单位置
      breadListPost: '1'
    }
  },
  computed: {
    muneListWidth () {
      const rate = this.browserSize / 100
      return 417 - ((217 * rate - 17) / rate) + 'px'
    },
    rotateIcon () {
      return [
        'menu-icon',
        this.isCollapsed ? 'rotate-icon' : ''
      ]
    },
    menuitemClasses () {
      return [
        'menu-item',
        this.isCollapsed ? 'collapsed-menu' : ''
      ]
    },
    logoClass () {
      return [
        this.isCollapsed ? 'sider-top-short' : 'sider-top'
      ]
    },
    // 获取机构名称
    orgCode () {
      return getOrgCode()
    },
    // 监听vuex中的位置
    openWhereLi () {
      return this.$store.state.Mune.openWhereLi
    },
    openWhereUl () {
      return this.$store.state.Mune.openWhereUl
    },
    // 监听面包屑数据
    breadList () {
      return this.$store.state.breadList
    },
    ...mapState({
      showPageAuthor: state => state.showPageAuthor,
      browserSize: state => state.browserSize,
      activeName: state => state.activeName
    })
  },
  methods: {
    // 左侧动画控制
    collapsedSider () {
      this.siderSelect = !this.siderSelect
      this.$refs.side1.toggleCollapse()
    },
    // 异步更新菜单
    openSiderList () {
      this.$nextTick(() => {
        this.$refs.side_menu.updateOpened()
        this.$refs.side_menu.updateActiveName()
      })
    },
    // 面包屑点击方法
    clickbread (path, indexVal, allData) {
      if (allData.type === '3' && path !== '') {
        this.$router.push(`${path}?${getUrlCode()}`)
      } else if (path !== '') {
        this.$router.push(path)
      }
    },
    // 改变菜单选中列表
    changeMuneList (actData) {
      const params = {
        openWhereUl: actData[0],
        openWhereLi: actData[1]
      }
      this.$store.commit('leftWhereSetect', params)
      this.openSiderList()
    },
    // 点击菜单的列表
    handleSelect (name) {
      // console.log('跳转' + name)
      this.$router.push(`/${this.orgCode}/${name}${window.location.search}`)
    },
    // 获取具体url名称
    getUrlName () {
      const cenrrtPath = this.$router.history.current.path.split(`/${this.orgCode}/`)[1]
      return cenrrtPath
    },
    // 从url中反推获取位置参数
    getPosition () {
      let cenrrtPath
      const urlArr = this.getUrlName().split('/')
      const urlLength = urlArr.length
      if (urlLength > 1) {
        // 获取最后一个名称字段即本页面的名称字段
        cenrrtPath = urlArr[urlLength - 1]
      } else {
        cenrrtPath = this.getUrlName()
      }
      const newList = this.breadListPost
      // 找寻菜单对应的模块字段
      const key = Object.keys(this.breadListPost)
      // 长度
      const leng = Object.keys(this.breadListPost).length
      // 定义ui,li
      let Ul, Li, data
      // console.log(cenrrtPath)
      // type=0单条数据，表层查找即可
      if (newList[cenrrtPath] !== undefined && newList[cenrrtPath].openWhereUl !== undefined) {
        Ul = [newList[cenrrtPath].openWhereUl]
        Li = newList[cenrrtPath].openWhereLi
        data = newList[cenrrtPath].breadListData
      } else {
        // type=1下拉无标题数据循环渲染
        for (let i = 0; i < leng; i++) {
          // console.log(key[i])
          // console.log(newList[key[i]])
          if (newList[key[i]].list !== undefined && newList[key[i]].list[cenrrtPath] !== undefined && newList[key[i]].list[cenrrtPath].openWhereUl !== undefined) {
            Ul = [newList[key[i]].list[cenrrtPath].openWhereUl]
            Li = newList[key[i]].list[cenrrtPath].openWhereLi
            data = newList[key[i]].list[cenrrtPath].breadListData
            break
          } else if (newList[key[i]].list !== undefined && newList[key[i]].list[cenrrtPath] === undefined) {
            const childListKey = Object.keys(newList[key[i]].list)
            try {
              childListKey.forEach((element, index) => {
                // 循环在list中继续寻找
                // console.log(element)
                // console.log(newList[key[i]].list[element])
                if (newList[key[i]].list[element] !== undefined && newList[key[i]].list[element].list !== undefined && newList[key[i]].list[element].list[cenrrtPath] !== undefined && newList[key[i]].list[element].list[cenrrtPath].openWhereUl !== undefined) {
                  Ul = [newList[key[i]].list[element].list[cenrrtPath].openWhereUl]
                  Li = newList[key[i]].list[element].list[cenrrtPath].openWhereLi
                  data = newList[key[i]].list[element].list[cenrrtPath].breadListData
                  // console.log([[Ul, Li], data])
                  throw new Error('主动终止foreach')
                }
              })
            } catch (e) {
              if (e.message !== '主动终止foreach') throw e
            }
            // type=2下拉带标题的再次深层查找
            // console.log(newList[key[i]])
            // return
            // break
          }
        }
      }
      let params
      Ul !== undefined && Li !== undefined && data !== undefined ? params = [[Ul, Li], data] : console.log('ul,li赋值失败请查看adminHome页面的getPosition方法')
      // console.log(params)
      return params
    },
    // 注销按钮
    closeLogin () {
      // 弹出提示框确认
      // this.modal1 = true
      confirm('警告', '确定退出？', () => {
        this.checkOk()
      }, '')
    },
    // 注销提醒
    checkOk () {
      removeCookie('readStar')
      removeCookie('level')
      removeCookie('id')
      this.$router.replace('/')
      this.$Message.success('成功退出')
    },
    checkCancel () {
      // this.$Message.info('Clicked cancel')
    },
    // 菜单、面包屑初始化
    cshPositionCard () {
      const positions = this.getPosition()
      // console.log(positions)
      this.changeMuneList(positions[0])
      const breadDate = positions[1]
      this.$store.state.breadList = breadDate
    },
    // 菜单初始化
    async getData () {
      let res
      if (this.orgCode === 'super') {
        // res = await supGetMuneInfo('', true)
        res = {
          code: 200,
          data: {
            index: "机构管理",
            items: [{
              id: "orgList",
              code: "orgList",
              name: "机构管理",
              type: 0,
              count: false,
              subMenu: []
            }]
          },
          message: "OK"
        }
      } else {
        // res = await orgGetMuneInfo(this.orgCode, '', true)
        res = {
          code: 200,
          data: {
            index: "报名信息",
            items: [
              {
                id: "userInfo",
                code: "userInfo",
                name: "报名信息",
                type: 0,
                count: false,
                subMenu: []
              }, {
                id: "workList",
                code: "workList",
                name: "作品列表",
                type: 0,
                count: false,
                subMenu: []
              }]
          },
          message: "OK"
        }
      }
      // 对左侧列表数据赋值
      if (res.code === 200) {
        this.getUserInfo()
        const leng = res.data.items.length
        let codeName, nextleng, nextCodeName
        for (var i = 0; i < leng; i++) {
          codeName = res.data.items[i].code
          if (res.data.items[i].type === 0 && this.muneListData[codeName]) {
            this.muneListData[codeName].type = 0
            this.muneListData[codeName].name = res.data.items[i].name
            if (this.muneListData[codeName].breadListData.length > 1) {
              this.muneListData[codeName].breadListData[0].name = res.data.index
              this.muneListData[codeName].breadListData[1].name = res.data.items[i].name
            } else if (this.muneListData[codeName].breadListData.length === 1) {
              this.muneListData[codeName].breadListData[0].name = res.data.items[i].name
            }
          } else if (res.data.items[i].type === 1 && this.muneListData[codeName]) {
            this.muneListData[codeName].type = 1
            this.muneListData[codeName].name = res.data.items[i].name
            nextleng = res.data.items[i].subMenu.length
            for (let n = 0; n < nextleng; n++) {
              nextCodeName = res.data.items[i].subMenu[n].code
              if (this.muneListData[codeName].list[nextCodeName]) {
                this.muneListData[codeName].list[nextCodeName].name = res.data.items[i].subMenu[n].name
                this.muneListData[codeName].list[nextCodeName].listType = '1'
                // 面包屑第一个是首页
                this.muneListData[codeName].list[nextCodeName].breadListData[0].name = res.data.index
                // 面包屑第二个是大模块名称
                this.muneListData[codeName].list[nextCodeName].breadListData[1].name = res.data.items[i].name
                // 面包屑第三个元素名称
                this.muneListData[codeName].list[nextCodeName].breadListData[2].name = res.data.items[i].subMenu[n].name
              }
            }
          } else if (res.data.items[i].type === 2 && this.muneListData[codeName]) {
            // 菜单下拉带标题的
            this.muneListData[codeName].type = 2
            this.muneListData[codeName].name = res.data.items[i].name
            // 把第一层的list赋值
            const currData = res.data.items[i].subMenu
            currData.forEach((element, index) => {
              const firstList = this.muneListData[codeName].list[element.code]
              // name同步
              firstList.name = element.title
              // 显示置1
              firstList.listType = 1
              // 接口数据的下一层
              const nextData = element.subMenu
              const nextList = firstList.list
              nextData.forEach((ele, ind) => {
                const targetList = nextList[ele.code]
                // 显示
                targetList.listType = 1
                targetList.name = ele.name
                // 面包屑
                // functionIndex
                targetList.breadListData[0].name = res.data.index
                // 模块名称
                targetList.breadListData[1].name = res.data.items[i].name
                // 标题
                targetList.breadListData[2].name = element.title
                // 具体标题
                targetList.breadListData[3].name = ele.name
                // nextList[ele.code] = targetList
              })
              // 反向赋值
              // this.muneListData[codeName].list[element.code] = firstList
            })
          }
        }
        this.breadListPost = this.muneListData
        // 在DOM创建好后调用方法
        this.cshPositionCard()
      } else {
        throw new Error('您还没有权限')
      }
    },
    // 获取信息
    async getUserInfo () {
      const orgIndo = await getUserInfo()
      handleRes(orgIndo, '', () => {
        // window.localStorage.setItem('userInfo', JSON.stringify(orgIndo.data))
        this.adminName = `${orgIndo.data.school}  ${orgIndo.data.name}`
      }, '', () => {
        backMessage(``, `您还没有进入该机构的权限，请联系管理员`)
      })
    }
  },
  async created () {
    // 获取默认数据
    await this.getData()
  },
  mounted () {
    window.onresize = () => {
      const screenHeight = document.documentElement.clientHeight;
      const tableHeight = screenHeight - 280;
      this.$store.commit('changeTableHeight', tableHeight);
    };
  },
  watch: {
    // 监听路由如果路由变化则改变菜单选中状态
    '$route' () {
      // console.log('路由发生了变化')
      this.cshPositionCard()
    }
  }
}
</script>
